import {ReactPortal, useEffect} from 'react';
import {createPortal} from 'react-dom';

import heartSrc from '../common/heart.png';

import * as styles from './grow-overlay.scss';

type PropsType = {
    duration: number;
    onFinish: () => void;
};

export function GlowOverlay(props: PropsType): ReactPortal {
    const {duration, onFinish} = props;

    useEffect(() => {
        const id = setTimeout(onFinish, duration + 50);

        return () => clearTimeout(id);
    }, [duration, onFinish]);

    return createPortal(
        <div aria-hidden className={styles.GrowOverlay_overlay}>
            <div className={styles.GrowOverlay_container}>
                <img alt="" className={styles.GrowOverlay_heart} src={heartSrc} />
            </div>
            <div className={`${styles.GrowOverlay_edge} ${styles.GrowOverlay_top}`} />
            <div className={`${styles.GrowOverlay_edge} ${styles.GrowOverlay_right}`} />
            <div className={`${styles.GrowOverlay_edge} ${styles.GrowOverlay_bottom}`} />
            <div className={`${styles.GrowOverlay_edge} ${styles.GrowOverlay_left}`} />
        </div>,
        document.body
    );
}
